import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { RouteConstants } from "../../constants/ApplicationConstants/RouteConstants";
import Authentication from "../../util/Authentication";
import LocalStorageUtil from "../../util/LocalStorageUtil";
import { LocalStorageConstants } from "../../constants/ApplicationConstants/LocalStorageConstants";
import { Modules, Operations, UserModuleAndIdMapping } from "../../constants/DatabaseConstants/MasterConstant";

import type { UserInterface } from "../../shared/interface/auth/User.interface";

const useUserManagement = () => {
  /* CONSTANT */
  const navigate = useNavigate();
  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  const defaultSelectedOption = Authentication.hasModuleAndOperationAccess(userData, Modules.WEB_USER, Operations.READ) ? UserModuleAndIdMapping.WEB_USER : Authentication.hasModuleAndOperationAccess(userData, Modules.MOBILE_USER, Operations.READ) ? UserModuleAndIdMapping.MOBILE_USER : null;
  /* STATE */
  /* searched text state */
  const [searchedText, setSearchedText] = useState<string>("");
  /* selected module Id */
  const [selectedId, setSelectedId] = useState<number | null>(defaultSelectedOption);

  /* HANDLERS */
  /* select id to get list of master */
  const handleListSelect = (value: number) => {
    setSelectedId(value);
    /* clear search input */
    setSearchedText("");
  };

  const handleChangeOnSearch = (value: string) => {
    const trimmedValue = value?.replace(/^\s+/, "");
    setSearchedText(trimmedValue);
  };

  const handleChangeSearch = (value: string) => {
    const trimmedValue = value?.replace(/^\s+/, "");
    setSearchedText(trimmedValue);
  };

  const handleAddClick = () => {
    navigate(`${RouteConstants.USER_MANAGEMENT_PAGE}/${RouteConstants.USER_FORM_ADD_PAGE}`);
  };

  return {
    userData,
    selectedId,
    searchedText,
    handleListSelect,
    handleAddClick,
    handleChangeOnSearch,
    handleChangeSearch
  };
};

export default useUserManagement;
